(function () {
    'use strict';
    // move ngstorage , common modules
    angular.module('logout', []);
    //.config(function($locationProvider) {
    //    $locationProvider.html5Mode(true);
    //    });
})();